import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import ExpandableParagraph from 'components/common/expandable_paragraph'
import Linkify from 'react-linkify'

const i18n = getI18n('components/campaign_details')
const MAX_ROWS = 200
const DEFAULT_ROWS = 3

class CampaignDetails extends React.Component {
  static propTypes = {
    details: PropTypes.string,
    tab_layout: PropTypes.bool,
  }
  static defaultProps = {
    tab_layout: false,
  }
  render() {
    if (!this.props.details) {
      return null
    }
    const title = this.props.tab_layout ? '' : i18n('title')
    const maxRows = this.props.tab_layout ? MAX_ROWS : DEFAULT_ROWS
    return (
      <ExpandableParagraph titleText={title} maxRows={maxRows}>
        <Linkify properties={{ target: '_blank' }}>
          {this.props.details}
        </Linkify>
      </ExpandableParagraph>
    )
  }
}

export default CampaignDetails
